import React from "react";
import Icon from "@ant-design/icons";

const NewCalendarIconSVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none">
    <path
      d="M26 4H23V3C23 2.73478 22.8946 2.48043 22.7071 2.29289C22.5196 2.10536 22.2652 2 22 2C21.7348 2 21.4804 2.10536 21.2929 2.29289C21.1054 2.48043 21 2.73478 21 3V4H11V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2C9.73478 2 9.48043 2.10536 9.29289 2.29289C9.10536 2.48043 9 2.73478 9 3V4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V26C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V6C28 5.46957 27.7893 4.96086 27.4142 4.58579C27.0391 4.21071 26.5304 4 26 4V4ZM21.1875 16.725L15.35 22.225C15.2592 22.314 15.1518 22.3841 15.0338 22.4313C14.9158 22.4785 14.7896 22.5018 14.6625 22.5C14.4063 22.501 14.1598 22.4024 13.975 22.225L10.8125 19.225C10.7109 19.1364 10.6283 19.0281 10.5696 18.9067C10.5109 18.7854 10.4774 18.6534 10.471 18.5187C10.4647 18.3841 10.4856 18.2495 10.5325 18.1231C10.5795 17.9968 10.6515 17.8812 10.7443 17.7834C10.8371 17.6856 10.9486 17.6075 11.0723 17.5539C11.196 17.5003 11.3293 17.4723 11.4641 17.4715C11.5989 17.4707 11.7325 17.4972 11.8568 17.5493C11.9811 17.6015 12.0936 17.6783 12.1875 17.775L14.6625 20.125L19.8125 15.275C19.9069 15.1833 20.0188 15.1114 20.1414 15.0635C20.2641 15.0157 20.395 14.9928 20.5266 14.9963C20.6583 14.9998 20.7878 15.0296 20.9078 15.0839C21.0277 15.1382 21.1356 15.2159 21.225 15.3125C21.4071 15.5049 21.5055 15.7617 21.4984 16.0265C21.4914 16.2913 21.3796 16.5425 21.1875 16.725V16.725ZM26 10H6V6H9V7C9 7.26522 9.10536 7.51957 9.29289 7.70711C9.48043 7.89464 9.73478 8 10 8C10.2652 8 10.5196 7.89464 10.7071 7.70711C10.8946 7.51957 11 7.26522 11 7V6H21V7C21 7.26522 21.1054 7.51957 21.2929 7.70711C21.4804 7.89464 21.7348 8 22 8C22.2652 8 22.5196 7.89464 22.7071 7.70711C22.8946 7.51957 23 7.26522 23 7V6H26V10Z"
      fill="url(#paint0_linear_426_216)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_426_216"
        x1="16"
        y1="2"
        x2="16"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#708AC2" />
        <stop offset="1" stop-color="#5673B2" />
      </linearGradient>
    </defs>
  </svg>
);

const NewCalendarIcon = (props) => (
  <Icon component={NewCalendarIconSVG} {...props} />
);

export default NewCalendarIcon;
